import DealerStockoutListPanel from "./dealerStockoutListPanel.container"

export default DealerStockoutListPanel
